import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import Header from "../../components/Header";
import SearchField from "../../components/Field";
import connect from "react-redux/es/connect/connect";
import PostsList from "./PostsList";
import BackButton from "../BackButton";
import Breadcrumbs from "../Breadcrumbs";
import { setPostSearchByName } from '../../redux/posts';


class Posts extends Component {
  search = this.props.postSearchByName && this.props.postSearchByName.length > 2 ? this.props.postSearchByName : "";
  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      updatedAt: Date.now(),
      searching: false,
      showMessage: false
    };
  }

  componentDidMount() {
    const { postSearchByName } = this.props;

    if (postSearchByName && postSearchByName.length > 2) {
      this.searchByTitle(postSearchByName);
      if (document.getElementById('post-search')) {
        document.getElementById('post-search').value = postSearchByName;
      }
    }
  }

  searchByTitle = title => {
    if (title && title.length >= 2) {
      this.setState({ filters: { title, isDraft: false }, searching: true }, () => {
        this.setState({ updatedAt: Date.now() });
      });
    } else {
      this.setState({ filters: { isDraft: false }, searching: true  }, () => {
        this.setState({ updatedAt: Date.now() });
      });
    }

    this.props.dispatch(setPostSearchByName(title));
  };

  render() {
    let title = this.search.length
      ? this.search
      : this.props.location.state &&
        this.props.location.state.search &&
        this.props.location.state.search;

    return (
      <div>
        <Header {...this.props} loading={this.props.loading}/>

        <Grid container className="dish-container show-all-post">
          <Grid
            className="chef-details-bc"
            container
            alignItems={"center"}
            justify={"space-between"}
            style={{margin: '40px auto 0', padding: 0, maxWidth: 1130, width: '100%' }}
          >
            <Breadcrumbs childRoutes={[
              {
                display: 'Posts',
                link: 'home/post-search'
              }
            ]} />
            {!this.props.isChef &&
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              {this.state.showMessage && <div style={{ color: '#ff8000', marginBottom: 10 }}>Press Enter key to search</div>}
              <SearchField
                id="post-search"
                type={"search"}
                placeholder={"Search posts"}
                onChange={evt => this.search = evt.target.value}
                onKeyDown ={evt => {
                  if (evt.key === 'Backspace') {
                    this.searchByTitle(this.search.length > 2 ? this.search : 'a');
                  }

                  if (this.search.length >= 2) this.setState({ showMessage: true });
                  else this.setState({ showMessage: false });
                }}
                onKeyPress={evt => {
                  if (evt.key === "Enter" || this.search.length > 2) {
                    this.searchByTitle(this.search);
                  } else {
                    this.searchByTitle('a');
                  }
                }}
              />
            </div>}
          </Grid>
          {!this.props.location.state &&
            this.props.userId &&
            !this.props.isChef && (
              <PostsList
                pageSize={500}
                next={null}
                previous={null}
                page="list"
                searching={this.state.searching}
              //  isShowAll={false}
                filters={{...this.state.filters, isDraft: false}}
                {...this.props}
              />
            )}
          {this.props.location.state && this.props.location.state.search && (
            <PostsList
              pageSize={500}
             // isShowAll={true}
              filters={{
                title,
                isDraft: false
              }}
              searching={this.state.searching}
              next={null}
              previous={null}
              page="list"
              {...this.props}
            />
          )}
          {this.props.userId && this.props.isChef && (
            <PostsList
              pageSize={500}
              isLiveShow={true}
              //isShowAll={true}
              filters={{ ...this.state.filters, chefId: this.props.userId, isDraft: false }}
              next={null}
              previous={null}
              page="portfolio"
              updatedAt={Date.now()}
              {...this.props}
            />
          )}
        </Grid>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    loading: state.posts.loading,
    postSearchByName: state.posts.postSearchByName
  };
};

const PostSearch = connect(mapStateToProps)(Posts);

export default PostSearch;
